import { listProductGroups } from "../../api/products.api";

export const fetchProductGroups = (pageSize = 100, page = 1, sortBy = "date_created", sortOrder = "desc", mfg_id = "", categoryId = "", searchTerm = "", groupType = "") => {
    return (dispatch) => {
        dispatch({ type: "SET_PRODUCT_GROUPS_LOADING", payload: true });

        const batchSize = Math.max(pageSize || 100, 100);

        return new Promise((resolveOuter) => {
            listProductGroups(batchSize, 1, sortBy, sortOrder, mfg_id, categoryId, searchTerm, groupType, async (response) => {
                if (response.status === 200) {
                    const initialData = response.data?.data || (Array.isArray(response.data) ? response.data : []);
                    const pagination = response.data?.pagination || {};
                    const totalPages = pagination.totalPages || 1;
                    const totalItems = pagination.totalItems || pagination.total || initialData.length;

                    // Dispatch page 1 immediately for instant UI render
                    dispatch({
                        type: "SET_PRODUCT_GROUPS",
                        payload: {
                            data: initialData,
                            pagination: {
                                totalItems: totalItems,
                                totalPages: totalPages,
                                currentPage: 1,
                                pageSize: batchSize
                            }
                        }
                    });

                    // If multiple pages exist, load remaining pages concurrently and merge
                    if (totalPages > 1) {
                        try {
                            const pagePromises = [];
                            const maxPages = Math.min(totalPages, 15); // Up to 1500 groups
                            for (let p = 2; p <= maxPages; p++) {
                                pagePromises.push(
                                    new Promise((resolve) => {
                                        listProductGroups(batchSize, p, sortBy, sortOrder, mfg_id, categoryId, searchTerm, groupType, (resNext) => {
                                            if (resNext.status === 200 && resNext.data) {
                                                const nextData = resNext.data?.data || (Array.isArray(resNext.data) ? resNext.data : []);
                                                resolve(nextData);
                                            } else {
                                                resolve([]);
                                            }
                                        });
                                    })
                                );
                            }

                            const nextBatches = await Promise.all(pagePromises);
                            let combined = [...initialData];
                            nextBatches.forEach((batch) => {
                                if (Array.isArray(batch)) {
                                    combined = combined.concat(batch);
                                }
                            });

                            // Deduplicate by ID
                            const uniqueMap = new Map();
                            combined.forEach((item) => {
                                if (item) {
                                    const id = item._id || item.groupId || item.id || item.slug;
                                    if (id) {
                                        uniqueMap.set(String(id), item);
                                    } else {
                                        uniqueMap.set(Math.random(), item);
                                    }
                                }
                            });
                            const allUniqueGroups = Array.from(uniqueMap.values());

                            dispatch({
                                type: "SET_PRODUCT_GROUPS",
                                payload: {
                                    data: allUniqueGroups,
                                    pagination: {
                                        totalItems: allUniqueGroups.length,
                                        totalPages: Math.ceil(allUniqueGroups.length / 10),
                                        currentPage: 1,
                                        pageSize: 10
                                    }
                                }
                            });
                        } catch (err) {
                            console.warn("Could not fetch remaining product groups pages:", err);
                        }
                    }
                } else {
                    dispatch({
                        type: "SET_PRODUCT_GROUPS_ERROR",
                        payload: response.message
                    });
                }
                dispatch({ type: "SET_PRODUCT_GROUPS_LOADING", payload: false });
                resolveOuter();
            });
        });
    };
};

